var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { CustomFieldType } from './models';
import { Icon, FormControl, Select, InputLabel, Grid, TextField, MenuItem, FormControlLabel, Checkbox } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
var CustomFieldEditor = /** @class */ (function (_super) {
    __extends(CustomFieldEditor, _super);
    function CustomFieldEditor(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "selectedOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        _this.state = _this.getUpdatedState();
        return _this;
    }
    Object.defineProperty(CustomFieldEditor.prototype, "hasOptions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            var fieldsWithOptions = [
                CustomFieldType.List,
                CustomFieldType.Radio,
                CustomFieldType.Checkbox
            ];
            return fieldsWithOptions.indexOf(type) !== -1;
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "getUpdatedState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            if (!this.hasOptions(this.props.field.type)) {
                return {
                    rows: [],
                    columns: []
                };
            }
            var columns = [{
                    field: 'name',
                    headerName: 'Name',
                    width: 100,
                    editable: true,
                    sortable: false,
                },
                {
                    field: 'value',
                    headerName: 'Value',
                    width: 150,
                    editable: true,
                    sortable: false
                }];
            var rows = (_b = (_a = this.props.field.options) === null || _a === void 0 ? void 0 : _a.map(function (o) {
                return {
                    id: o.name,
                    name: o.name,
                    value: o.value,
                };
            })) !== null && _b !== void 0 ? _b : [];
            return {
                columns: columns,
                rows: rows
            };
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var style = { marginRight: '5px' };
            return (_jsxs(Grid, __assign({ container: true, direction: "column" }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12, container: true, direction: "row", alignItems: "center" }, { children: [_jsxs(Grid, __assign({ item: true, container: true, xs: 2, direction: "row", justifyContent: "center" }, { children: [_jsx(IconButton, __assign({ size: "small", onClick: function (e) { return _this.onMoveUp(); } }, { children: _jsx(Icon, { children: "arrow_drop_up" }, void 0) }), void 0), _jsx(IconButton, __assign({ size: "small", onClick: function (e) { return _this.onMoveDown(); } }, { children: _jsx(Icon, { children: "arrow_drop_down" }, void 0) }), void 0), _jsx(IconButton, __assign({ size: "small", onClick: function (e) { return _this.onDelete(); } }, { children: _jsx(Icon, { children: "delete" }, void 0) }), void 0)] }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: style }, { children: _jsx(Autocomplete, { options: this.getPredefinedFields(), disableClearable: true, freeSolo: true, value: this.props.field.name, inputValue: this.props.field.name, onChange: function (e, v) { return _this.onAutocompleteNameChanged(e, v); }, onInputChange: function (e, v) { return _this.onNameChanged(e, v); }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { label: "Field name", fullWidth: true, required: true, placeholder: "Field name" }), void 0); } }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: style }, { children: _jsx(TextField, { label: "Field title", fullWidth: true, placeholder: (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabelForField(this.props.field), onChange: function (e) { return _this.onLabelChanged(e); }, InputLabelProps: { shrink: true }, value: this.props.field.defaultLabel }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: style }, { children: this.renderFieldTypeEditor() }), void 0), _jsx(Grid, __assign({ item: true, xs: 1, style: style }, { children: this.renderSizeEditor() }), void 0), _jsx(Grid, __assign({ item: true, xs: 1, style: style }, { children: this.renderIsMandatorySettings() }), void 0)] }), void 0), this.renderOptionsEditor()] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "getPredefinedFields", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            var keys = (_b = (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getKeys()) !== null && _b !== void 0 ? _b : [];
            return _.sortBy(keys.filter(function (k) { return k.startsWith('Field.'); }));
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "renderFieldTypeEditor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(FormControl, __assign({ fullWidth: true }, { children: [_jsx(InputLabel, { children: "Field type" }, void 0), _jsxs(Select, __assign({ value: this.props.field.type, onChange: function (e) { return _this.onTypeChange(e); }, label: "Field type" }, { children: [_jsx(MenuItem, __assign({ value: CustomFieldType.Text }, { children: "Text" }), void 0), _jsx(MenuItem, __assign({ value: CustomFieldType.LongText }, { children: "Long text" }), void 0), _jsx(MenuItem, __assign({ value: CustomFieldType.Number }, { children: "Number" }), void 0), _jsx(MenuItem, __assign({ value: CustomFieldType.Checkbox }, { children: "Checkbox" }), void 0), _jsx(MenuItem, __assign({ value: CustomFieldType.Radio }, { children: "Radio" }), void 0), _jsx(MenuItem, __assign({ value: CustomFieldType.List }, { children: "List" }), void 0), _jsx(MenuItem, __assign({ value: CustomFieldType.LineBreak }, { children: "Line break" }), void 0)] }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onTypeChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldType(this.props.field, e.target.value);
            this.setState(this.getUpdatedState());
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "renderSizeEditor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsx(TextField, { type: "number", label: "Width", fullWidth: true, placeholder: "Width", onChange: function (e) { return _this.onWidthChanged(e); }, value: this.props.field.width }, void 0));
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "renderVisibleSettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsx(FormControlLabel, { label: "Show on the overview", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: this.props.field.isVisibleOverview }, void 0) }, void 0));
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "renderIsMandatorySettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            switch (this.props.field.type) {
                case CustomFieldType.Text:
                case CustomFieldType.LongText:
                case CustomFieldType.Number:
                case CustomFieldType.List:
                    return (_jsx(FormControlLabel, { label: "Mandatory", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: this.props.field.isMandatory, onChange: function (e) { return _this.onMandatoryChanged(e); } }, void 0) }, void 0));
                default:
                    return null;
            }
            ;
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "renderOptionsEditor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (this.state.columns.length === 0)
                return null;
            return (_jsxs(Grid, __assign({ container: true, item: true, xs: 12 }, { children: [_jsx(Grid, { item: true, xs: 2 }, void 0), _jsxs(Grid, __assign({ item: true, container: true, xs: 5 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, style: { marginTop: '10px', minHeight: '150px' } }, { children: _jsx(DataGrid, { rows: this.state.rows, columns: this.state.columns, headerHeight: 30, rowHeight: 30, onCellEditCommit: function (p) { return _this.onCellEditCommit(p); }, onSelectionModelChange: function (e) { return _this.onSelectionModelChange(e); }, disableColumnMenu: true, hideFooter: true }, void 0) }), void 0), _jsxs(Grid, __assign({ item: true }, { children: [_jsx(IconButton, __assign({ onClick: function (e) { return _this.onAddOptionClick(); } }, { children: _jsx(Icon, { children: "add" }, void 0) }), void 0), _jsx(IconButton, __assign({ onClick: function (e) { return _this.onRemoveOptionClick(); } }, { children: _jsx(Icon, { children: "remove" }, void 0) }), void 0)] }), void 0)] }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onSelectionModelChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            this.selectedOption = e.length === 0 ? '' : e[0];
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onCellEditCommit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (p) {
            var _a, _b;
            if (p.field === 'name')
                (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldOptionName(this.props.field, p.id, p.value);
            else if (p.field === 'value')
                (_b = this.props.fieldsStore) === null || _b === void 0 ? void 0 : _b.updateFieldOptionValue(this.props.field, p.id, p.value);
            else
                return;
            this.setState(this.getUpdatedState());
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onWidthChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldWidth(this.props.field, parseInt(e.target.value));
            this.setState(this.getUpdatedState());
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onMandatoryChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldMandatory(this.props.field, e.target.checked);
            this.setState(this.getUpdatedState());
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onAddOptionClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.addFieldOption(this.props.field);
            this.setState(this.getUpdatedState());
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onRemoveOptionClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            if (this.selectedOption) {
                (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.removeFieldOption(this.props.field, this.selectedOption);
                this.setState(this.getUpdatedState());
            }
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onNameChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, value) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldName(this.props.field, value !== null && value !== void 0 ? value : '');
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onAutocompleteNameChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, value) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldName(this.props.field, value !== null && value !== void 0 ? value : '');
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onLabelChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldLabel(this.props.field, e.target.value);
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onMoveUp", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.moveFieldUp(this.props.field);
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onMoveDown", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.moveFieldDown(this.props.field);
        }
    });
    Object.defineProperty(CustomFieldEditor.prototype, "onDelete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.removeField(this.props.field);
        }
    });
    CustomFieldEditor = __decorate([
        inject('languageStore'),
        inject('fieldsStore'),
        observer
    ], CustomFieldEditor);
    return CustomFieldEditor;
}(React.Component));
export default CustomFieldEditor;
